// /**
//  * Partner - Detail
//  */

// React
import React, { useContext, useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  getUsersByPartnerIdAction,
  getUsersBeAdminPartnerAction,
  updatePartnerAdminActions,
  getPartnerWithIdAction,
} from '../partners/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectUsersListByPartnerId,
  makeSelectUsersListBeAdminPartner,
  makeSelectError,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectPartner,
} from '../partners/selectors';

// UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Paper,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiMapMarkerOutline,
  mdiAccountTie,
  mdiClose,
  mdiAccountPlus,
  mdiAccountArrowRight, mdiAccountPlusOutline,
} from '@mdi/js';

// Helper
import { formaterPhoneNumber } from '../../utils/helpers';

// Components
import ListUser from './list-users';
import AddUser from './add-user';

// Type
import { SelectorPropsDetail, PropsDetail, PayloadUpdate } from './interfaces';
import theme from '../../theme';
import AuthContext from '../../authContext';
import Add from './components/add';
import { User } from '../users/interfaces';
import Modal from '../../components/Modal';
import usersRepository from 'client-sdk/src/Repository/users-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(4),
      border: '1px solid #ddd',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    textInput: {
      width: '100%',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },
      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
  })
);

function Detail(props: PropsDetail) {
  const classes = useStyles();
  const [openAddUser, setOpenAddUser] = useState(false as boolean);
  const [openAllocateUser, setOpenAllocateUser] = useState(false as boolean);
  const authContext = useContext(AuthContext);
  const partnerId = Number(authContext.user.partnerId);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);

  useEffect(() => {
    getUsers();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getUsers = () => {
    props.usersByPartnerIdDispatch({
      'partnersId.equals': partnerId,
    });
  }

  useEffect(() => {
    getPartner();
  }, []);

  const handleClose = () => {
    setOpenAllocateUser(false);
  };

  const handleCloseAddUser = () => {
    setOpenAddUser(false);
  };

  const getPartner = () => {
    props.getPartnerDispatch({ id: partnerId });
  };

  const createUser = async (payload: any) => {
    try {
      const { response, callback } = await usersRepository.createUser({ payload })
      handleNotfication("کاربر جدید با موفقیت اضافه شد", "success")
      callback && callback()
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <>
      <Grid container spacing={5} alignItems="flex-start">
        <Grid item xs={12}>
          <Paper
            elevation={3}
            className={classes.paper}
            variant="elevation"
            square
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiAccountOutline} size={1} />
                  {`نام شرکت:  `}
                  <span>{props.partner?.name}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon
                    path={mdiPhoneOutline}
                    size={1}
                    style={{ transform: 'scale(-1, 1)' }}
                  />
                  {`شماره تماس:  `}
                  <span>{formaterPhoneNumber(props.partner.phoneNumber)}</span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.item}>
                  <Icon path={mdiMapMarkerOutline} size={1} />
                  {`آدرس:  `}
                  <span>{props.partner.address}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiAccountTie} size={1} />
                  {`نماینده شرکت:`}
                  <span>{props.partner.representative}</span>
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid container spacing={2} item xs={12} direction="row-reverse">
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiAccountPlus} size={1} />}
              onClick={() => setOpenAddUser(true)}
            >
              {`ایجاد کاربر جدید`}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Icon path={mdiAccountArrowRight} size={1} />}
              onClick={() => setOpenAllocateUser(true)}
            >
              {`اختصاص کاربر به شرکت`}
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Paper>
            {
              <>
                <ListUser
                  data={props.usersByPartnerId}
                  partnerId={partnerId}
                  updatePartnerDispatch={props.updatePartnerAdminDispatch}
                />
              </>
            }
          </Paper>
        </Grid>
      </Grid>

      <Modal
        onClose={handleCloseAddUser}
        open={openAddUser}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiAccountPlusOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <Add
            onClose={handleCloseAddUser}
            error={props.error}
            createUser={async (body: User, callback: () => void) => {
              createUser({
                body,
                pagination: filtersValues,
                callback: () => {
                  handleCloseAddUser();
                  getUsers();
                },
              })
            }}
          />
        }
      />

      <Dialog
        maxWidth={'xl'}
        open={openAllocateUser}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <Grid container justify="flex-end">
            <Button aria-label="details" size="medium" onClick={handleClose}>
              <Icon path={mdiClose} size={1} />
            </Button>
          </Grid>
          <div>{`اختصاص کاربر به شرکت ${props.partner?.name}`}</div>
        </DialogTitle>
        <DialogContent>
          <AddUser
            handleClose={handleClose}
            usersList={props.usersBeAdminPartner}
            usersBeAdminPartnerDispatch={props.usersBeAdminPartnerDispatch}
            updatePartnerDispatch={props.updatePartnerAdminDispatch}
            partnerId={partnerId}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorPropsDetail>({
  usersByPartnerId: makeSelectUsersListByPartnerId(),
  usersBeAdminPartner: makeSelectUsersListBeAdminPartner(),
  partner: makeSelectPartner(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getPartnerDispatch: (payload: { id: number }) =>
      dispatch(getPartnerWithIdAction(payload)),
    usersByPartnerIdDispatch: (payload: Object) =>
      dispatch(getUsersByPartnerIdAction(payload)),
    usersBeAdminPartnerDispatch: (payload: Object) =>
      dispatch(getUsersBeAdminPartnerAction(payload)),
    updatePartnerAdminDispatch: (payload: PayloadUpdate) =>
      dispatch(updatePartnerAdminActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Detail);
